import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

function initializeSliderSelectionProducts(containerId) {
    const slider = new Swiper(containerId, {
        modules: [Navigation],
        slidesPerView: 1,
        loop: false,
        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
        },
    });
}

$(function () {
    initializeSliderSelectionProducts('#slider-selection-product');
});